import React from 'react';
import { Button, ButtonProps, Typography } from '@mui/material';

export type BBProps = ButtonProps & {
  label: string;
  secondarylabel?: string;
  buttonfill?: boolean | string;
  fontSize?: number;
  width?: string;
};

export const BlueButton = (props: BBProps): JSX.Element => {
  return (
    <Button
      {...props}
      variant="outlined"
      type={props.type}
      sx={{
        borderColor: 'info.main',
        backgroundColor: props.buttonfill ? 'info.main' : 'background',
        borderRadius: 0,
        minWidth: props.width || '20%',
        cursor: props.disabled ? 'initial' : 'cursor',
        '&.MuiButtonBase-root:hover': {
          bgcolor: props.buttonfill ? 'none' : 'transparent',
        },
      }}
    >
      <Typography
        variant="light"
        sx={{
          color: props.buttonfill ? 'white' : 'info.main',
          fontSize: props.fontSize || 18,
          width: '100%',
          textAlign: props.secondarylabel ? 'right' : 'center',
        }}
      >
        {props.label}
      </Typography>
      {props.secondarylabel && (
        <Typography
          variant="light"
          sx={{
            color: props.buttonfill ? 'white' : 'info.main',
            fontSize: props.fontSize || 18,
            textAlign: 'right',
            width: '100%',
          }}
        >
          {props.secondarylabel}
        </Typography>
      )}
    </Button>
  );
};
